/**
 * 美股顶部基本信息
 */
import React from "react"
import { store } from "./store"
import { single_quote, quote_item_name, quote_chart } from "../../shared/quotedata/index"
import { Observer } from "mobx-react-lite"
import { LoadMore } from "../../shared/quote_load_more"
import { ChartType } from "../../shared/utils"
import { StockHeaderErrorTradeStatus } from "../../shared/error_trade_status"
import { StockErrorTradeStatus } from "../../shared/pagetype"

export function USBasicInfo(props: { trade_status: StockErrorTradeStatus }) {
  return (
    <Observer>
      {() => (
        <div className="datas">
          <div className="top-p">
            <StockHeaderErrorTradeStatus store={store} trade_status={props.trade_status} />
            <div>
              <div className="row">
                {store.chartType != ChartType.分时 && store.chart_mouse_move_data ? (
                  <>
                    <p>
                      <span>今开</span>
                      {quote_chart[quote_item_name.今开](store.chart_mouse_move_data.jinkai, store.chart_mouse_move_data.jkColor).element}
                    </p>
                    <p>
                      <span>最高</span>
                      {quote_chart[quote_item_name.最高](store.chart_mouse_move_data.maxPrice, store.chart_mouse_move_data.maxPriceColor).element}
                    </p>
                    <p>
                      <span>最低</span>
                      {quote_chart[quote_item_name.最低](store.chart_mouse_move_data.minPrice, store.chart_mouse_move_data.minPriceColor).element}
                    </p>
                  </>
                ) : (
                  <>
                    <p>
                      <span>今开</span>
                      {single_quote[quote_item_name.今开](store.StockDetail).element}
                    </p>
                    <p>
                      <span>最高</span>
                      {single_quote[quote_item_name.最高](store.StockDetail).element}
                    </p>
                    <p>
                      <span>最低</span>
                      {single_quote[quote_item_name.最低](store.StockDetail).element}
                    </p>
                  </>
                )}
              </div>
              <div className="row">
                {store.chart_mouse_move_data ? (
                  <>
                    <p>
                      <span>换手</span>
                      {quote_chart[quote_item_name.换手](store.chart_mouse_move_data.huanshou).element}
                    </p>
                    <p>
                      <span>总量</span>
                      {quote_chart[quote_item_name.总手](store.chart_mouse_move_data.zongshou).element}
                    </p>
                    <p>
                      <span>总值</span>
                      {single_quote[quote_item_name.总市值](store.StockDetail).element}
                    </p>
                  </>
                ) : (
                  <>
                    <p>
                      <span>换手</span>
                      {single_quote[quote_item_name.换手](store.StockDetail).element}
                    </p>
                    <p>
                      <span>总量</span>
                      {single_quote[quote_item_name.总手](store.StockDetail).element}
                    </p>
                    <p>
                      <span>总值</span>
                      {single_quote[quote_item_name.总市值](store.StockDetail).element}
                    </p>
                  </>
                )}
              </div>
            </div>
          </div>
          <div className="bottom-p">
            {store.chartType == ChartType.日K && store.chart_mouse_move_data ? (
              <>
                <p>
                  {quote_chart[quote_item_name.日K时间](store.chart_mouse_move_data.time).element}
                  <span></span>
                </p>
                <p></p>
                <p></p>
              </>
            ) : (
              <>
                <p>
                  <span>52周高</span>
                  {single_quote[quote_item_name["52周最高价"]](store.StockDetail).colored_element}
                </p>
                <p>
                  <span>52周低</span>
                  {single_quote[quote_item_name["52周最低价"]](store.StockDetail).colored_element}
                </p>
                <p>
                  <span>市盈</span>
                  <sup>TTM</sup>
                  {single_quote[quote_item_name.市盈率](store.StockDetail).element}
                </p>
              </>
            )}
            <LoadMore />
          </div>
        </div>
      )}
    </Observer>
  )
}
